<template>
  <div
    :class="
      $isInApp
        ? 'padding-app'
        : $isLoginFree
        ? 'padding-h5-login-free'
        : 'padding-h5'
    "
  >
    <!-- 活动标题 -->
    <div style="position: relative">
      <div v-if="$$(titleInfo.cnt_describe)" class="home_header_top_title_name">
        {{ $$(titleInfo.cnt_describe).title }}
      </div>
      <div class="home_header_top_title_subname">
        {{ $$(titleInfo.cnt_describe).subtitle }}
      </div>
      <!-- 续报说明 -->
      <div
        v-if="stateIsLogin && $$(titleInfo.cnt_describe)"
        class="rule"
        @click="handleExplain"
      >
        续报说明
      </div>
    </div>
    <!-- 续报说明 弹窗-->
    <van-popup
      v-model="showPopUp"
      :close-on-click-overlay="true"
      closeable
      position="bottom"
      round
    >
      <div class="home_xb_explain_content_point_ares_header_title">
        {{ $$(titleInfo.cnt_describe).title || "" }}
      </div>
      <div
        v-if="
          titleInfo.cnt_describe &&
          titleInfo.cnt_describe.rules &&
          titleInfo.cnt_describe.rules.length > 0
        "
        class="home_xb_explain_content_point_ares_allcontent"
      >
        <div
          v-for="(ruleItem, ruleIndex) of titleInfo.cnt_describe.rules"
          :key="ruleIndex"
          class="home_xb_explain_content_point_ares_content"
          style="display: flex; flex-flow: column"
        >
          <h5 class="home_xb_explain_content_point_ares_content_title">
            {{ ruleItem.title }}
          </h5>
          <div class="home_xb_explain_content_point_ares_content_content">
            <p
              v-for="(content, contentIndex) of ruleItem.content"
              :key="contentIndex"
            >
              {{ content }}
            </p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Popup } from "vant";

export default {
  props: {
    titleInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showPopUp: false,
    };
  },
  components: {
    "van-popup": Popup,
  },
  computed: {
    ...mapState({
      stateUserId: (state) => state.userId,
      stateIsLogin: (state) => state.isLogin,
    }),
  },
  methods: {
    /** 续报说明 处理续报说明的弹窗 弹出or关闭*/
    handleExplain() {
      this.showPopUp = true;
      this.$xesLogger.clickMsg({
        params: { click_id: "click_bZkYzObX", click_name: "续报说明点击" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../index.less";

.padding-app {
  position: relative;
  padding-top: 2px;
}
.padding-h5 {
  position: relative;
  padding-top: 52px;
}
.padding-h5-login-free {
  position: relative;
  padding-top: 85px;
}
.rule {
  position: absolute;
  top: 33px;
  right: 0;
  width: 60px;
  height: 24px;
  line-height: 24px;
  z-index: 2;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  background: rgba(228, 12, 0, 0.7);
  border-radius: 24px 0 0 24px;
}
/deep/ .van-popup__close-icon {
  color: #333333;
  font-size: 18px;
}
</style>
